import { render } from "./ActionSendSms.vue?vue&type=template&id=23ed3ea3"
import script from "./ActionSendSms.vue?vue&type=script&lang=ts"
export * from "./ActionSendSms.vue?vue&type=script&lang=ts"
script.render = render

export default script